module.exports = __webpack_public_path__ + "static/media/level-nine.6d994fba.svg";